import styled from "styled-components"

export const InputButton = styled.div`
  color: #fff;
  margin-right: 20px;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  cursor: pointer;
  padding: 0 30px;
  background: #ed4e2a url(${require("../../Assets/images/camera.png")})
    no-repeat right 20px center;
  margin-bottom: 15px;
`
